import React, { useContext } from 'react';
import LanguageContext from '../contexts/LanguageContext';
import { translations } from '../translations';

const Business = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  return (
    <section className="bg-slate-50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Business Model */}
        <div className="text-center mb-12">
          <span className="inline-block mb-4 text-sm font-bold uppercase tracking-widest text-indigo-600">
            {t.business.model.label}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900">
            {t.business.model.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto mb-6">
          {t.business.model.cards.map((card, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg border-t-4 border-indigo-500"
            >
              <h3 className="text-xl font-bold text-slate-900 mb-3">
                {card.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {card.description}
              </p>
            </div>
          ))}
        </div>

        <p className="text-center text-lg font-semibold text-indigo-700 mb-20">
          {t.business.model.note}
        </p>

        {/* Vision */}
        <div className="max-w-4xl mx-auto rounded-3xl bg-gradient-to-br from-indigo-600 to-violet-700 text-white p-10 md:p-14 text-center shadow-xl">
          <span className="inline-block mb-4 text-sm font-bold uppercase tracking-widest text-amber-300">
            {t.business.vision.label}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 leading-tight">
            {t.business.vision.title}
          </h2>
          <p className="text-lg md:text-xl text-indigo-100 leading-relaxed mb-6">
            {t.business.vision.description}
          </p>
          <p className="text-xl md:text-2xl font-bold mb-6">
            {t.business.vision.highlight}
          </p>
          <p className="text-base md:text-lg text-indigo-200 italic">
            {t.business.vision.note}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Business;
